var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"start-button gradient",attrs:{"disabled":_vm.loading},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.displayedText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }